import { createContext } from "react";
import { infoMessages } from "../../infoMessages";

const InfoContext = createContext(infoMessages.default);

export default InfoContext;
